<template>
	<div id="printList">
		<div class="br-contentpanel">
	      <div class="br-pagebody pd-x-20 pd-sm-x-30">
		    <div class="card bd-0" id="orderManagerList">
			    <ul class="list-group purchase-img-wrap" v-for="(item, index) in orderLi">
			    	<li class="list-group-item rounded-top-0 pd-15 bd-0">
				  		<div class="row mg-0">
				  			<div class="d-flex align-items-center">
					            <div class="mg-r-30">
				              		<span class="mg-r-0">{{$t('other.订单号')}}:</span>
				              		<span class="tx-gray-300">{{item.code}}</span>
				              	</div>
				              	<div class="mg-r-30">
				              		<span class="mg-r-0">{{$t('other.商品种类')}}:</span>
				              		<span class="tx-gray-300 mg-r-15">{{item.itemCnt}}</span>
				              		<span class="mg-r-0">{{$t('other.数量')}}:</span>
				              		<span class="tx-gray-300">{{item.itemQuantity}}</span>
			              		</div>
			              		<div class="mg-r-30">
				              		<span class="mg-r-0">{{$t('other.商品总额（¥）')}}:</span>
				              		<span class="tx-gray-300 mg-r-15">{{item.totalAmount}}</span>
				              		<span class="mg-r-0">{{$t('other.运费')}}:</span>
				              		<span class="tx-gray-300">{{item.shippingAmount}}</span>
			              		</div>
				              	<div class="mg-r-30">
				              		<span class="mg-r-0">{{$t('other.客户')}}:</span>
				              		<span class="tx-gray-300">{{item.distributorName}}</span>
			              		</div>
				           </div>
				  		</div>
				  	</li>
				  	<li class="list-group-item rounded-top-0 pd-15 bd-0" v-for="(itemjson, indexjson) in (item.itemJson)">
				  		<div class="row mg-0">
				  			<div class="d-flex align-items-center">
					            <a class="p-img-wrap" href="javascript:;" :style="{backgroundImage: 'url('+ (showImg(itemjson.imgUrl) ? showImg(itemjson.imgUrl):'img/none-img.png') +')'}">
					            </a>
					            <div class="p-info">
					              <p class="mg-b-5">
					                <span class="tx-white">{{itemjson.name}}</span>
					              </p>
					              <div class="row">
					              	<div class="col-md-4">
					              		<div>
						              		<span class="mg-r-5">SKU:</span>
						              		<span class="tx-gray-300">{{itemjson.sku}}</span>
						              		<a
				                        v-show="itemjson.sku"
				                        class="to-clipboard tx-info mg-l-5"
				                        href="javascript:;"
				                        :data-clipboard-text="itemjson.sku"
				                      >
				                        <i class="icon ion-clipboard"></i>
				                      </a>
						              	</div>
						              	<div>
						              		<span class="mg-r-5">{{$t('other.采购价（¥）')}}:</span>
						              		<span class="tx-gray-300">{{itemjson.price}}</span>
					              		</div>
					              	</div>
					              	<div class="col-md-8">
					              		<div>
						              		<span class="mg-r-5">{{$t('other.属性')}}:</span>
						              		<span class="tx-gray-300" v-text="showProperty(itemjson.property)"></span>
					              		</div>
					              		<div>
						              		<span class="mg-r-5">{{$t('other.采购数量')}}:</span>
						              		<span class="tx-gray-300">{{itemjson.quantity}}</span>
					              		</div>
					              	</div>
					              </div>
					            </div>
				           </div>
				  		</div>
				  	</li>
				</ul>
			</div>	
		  </div>
	    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	orderLi:[],
    	openInner: [],
          orderStatus: {
            "1": this.$t('other.未付款'),
            "2": this.$t('other.待配货'),
            "3": this.$t('other.待发货'),
            "4": this.$t('other.已发货'),
            "5": this.$t('other.已完成'),
            "6": this.$t('other.已取消') ,
            "7": this.$t('other.异常'),
            "8": this.$t('other.部分发货')
          },
          paymentType: {
            "0": this.$t('other.其他')  ,
            "1": this.$t('other.线上结算'),
            "2": this.$t('other.账期结算'),
            "9": this.$t('other.金融方案')
          }
    };
  },
  mounted() {
  	this.getOrderList();
  },
  methods: {
  	getOrderList() {
      let vm = this;
      let getData = data => {
        this.orderLi = data.Results ? data.Results : [];
      };
      $.api_call("api.Order.findBySupplier", {
      	code:this.$route.params.code
      }, function(r) {
        if (r.ErrorCode == "9999") {
          getData(r.Data);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    openInnerFormat() {
      this.openInner = [];
      for (let i = 0; i < this.order_li.length; i++) {
        this.openInner.push(true);
      }
    },
    innerTableStatus(i) {
      this.$set(this.openInner, i, !this.openInner[i]);
    },
    showArr(arr) {
      if (arr && arr != "Array") {
        arr = JSON.parse(arr);
      } else {
        arr = "";
      }
      return arr;
    },
    showImg(img) {
      if (img) {
        img = img.replace('"', "").replace(/[\\]/g, "");
      } else {
        img = "";
      }
      return img;
    },
    showProperty(pro) {
      if (pro) {
        pro = pro.replace("||", " , ");
      } else {
        pro = "";
      }
      return pro;
    }
  },
  components: {
    
  }
};
</script>

<style>

</style>